import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    LanguageOptions:"",
}

const LanguageOptionSlice = createSlice({
    name: "LanguageOptionSlice",
    initialState,

    reducers: {
        LanguageOptionsData(state, action) {
            return {
                    LanguageOptions:action.payload.LanguageOptions,
            };
        }
    }
})
export const { LanguageOptionsData } = LanguageOptionSlice.actions;
export default LanguageOptionSlice.reducer;